import axios from "axios";
import { SendEmailEndpoint, Base } from "../config";

export const sendEmail = async (body) => {
  try {
    const response = await axios.post(SendEmailEndpoint, body);
    console.log("sendEmail response here", response.status);

    return { data: response.data, status: response.status, error: null };
  } catch (err) {
    // axios puts useful info on err.response when server responded with non-2xx
    const status = err?.response?.status ?? 500;
    const data = err?.response?.data ?? null;

    console.log("sendEmail error", status, data, err?.message);

    return { data, status, error: "Error sending inquiry email" };
  }
};

export const sendConfirmationEmail = async (data) => {
  try {
    const response = await axios.post(`${Base}/email/sendEmail`, data);
    console.log("sendConfirmationEmail response here", response.status);

    return { data: response.data, status: response.status, error: null };
  } catch (err) {
    const status = err?.response?.status ?? 500;
    const respData = err?.response?.data ?? null;

    console.log("sendConfirmationEmail error", status, respData, err?.message);

    return {
      data: respData,
      status,
      error: "Error sending confirmation email",
    };
  }
};
